import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCurateOutletProjectPermission = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("curate/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.ProjectPermission />,
        });
      })
      .catch(reject);
  });
});

export const LazyCurateOutletProjectPermission = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCurateOutletProjectPermission />
    </Suspense>
  );
};
